exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-grow[data-v-00897255]{width:5rem;height:5rem}.full-screen[data-v-00897255]{position:fixed}.inside-parent[data-v-00897255]{position:absolute}.loader[data-v-00897255]{display:block;width:100%}.loader div[data-v-00897255]{color:#c61e56}.preview-loader[data-v-00897255]{margin-left:65%;margin-top:10%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00897255","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Loader.vue
// module id = cjoW
// module chunks = 82 101 102